module.exports = __webpack_public_path__ + "img/CF_1N.1.6fa3e16e.jpg";